module.exports = __webpack_public_path__ + "img/284.16104ea8.png";